





















































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary ,ApplicationSubmit } from '@/entities';
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import NegotiationLog from './NegotiationLog.vue';

const namespace: string = "application";

@Component({
    components: {
        ProgressBar,
        WorkflowButtons,
        NegotiationLog,
        ValidationMessageComponent
    }
})
export default class SummaryComponent extends Vue {

    @State(namespace) application!: Workspace;
    @Getter("rootTemplate", { namespace }) schema: any;
    @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;
    @Action("updateTopMenu", { namespace: "application" }) updateMenu: any;
    @Action("getApplicantSummary", { namespace }) getApplicantSummary: any;
    @Action("saveApplication", { namespace: "application" }) save: any;
    @Action("saveAppData", { namespace: "application" }) saveAppData: any;
    @Action("resetTabs", { namespace }) resetActiveTabs: any;
    id: string = "0";
    validationMessages: any = [];
    errDialog: boolean = false;

    /** mounted fn */
    mounted() {
        /* get the application data **/
        //this.getApplication(this.application.selectedApplication);
    }

    updateKey(key: string) {
        // this.updateMenu(key);
        this.$router.push({
            name: "applicantapply",
            params: { applicationId: this.id, section: key }                                  
        });
    }

    /** show validations */
    showValidation(msgs: any) {
        this.application.validationMessages = msgs;
        this.application.showValidationDilog = true;
    }

    // validation dialog closed
    validationDialogClosed() {
        this.application.showValidationDilog = false;
        this.application.validationMessages = [];
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }

    // redirect to application form on validation message click
    validationMessageClicked(msg: any) {
        this.application.showValidationDilog = false;
        this.application.validationMessages = [];

        if(msg.SectionKey) {
            if(msg.SubSectionKey) {
                this.$router.push({
                    name: "applicantapply",
                    params: { applicationId: this.id, section: msg.SectionKey },    
                    hash: `#${msg.SubSectionKey}`
                });
            } else {
                this.$router.push({
                    name: "applicantapply",
                    params: { applicationId: this.id, section: msg.SectionKey }
                });
            }  
        }              
    }

    /** calculate the margin */
    computedMargin(value: number): string {
        if(value < 25) {
            return 'padleft-0'
        } else if (value < 50){
            return 'padleft-25'
        } else if (value < 75){
            return 'padleft-50'
        } else {
            return 'padleft-75'
        }
    }

    buttonAction(item) {
        this.application.application.WorkflowStatusId = item.StepId;
        this.application.application.Comments = item.Comments;
        this.application.application.Subject = item.Subject;
        this.application.application.notify = item.notify;
        return this.save({
                    data: this.application.application,
                    id: this.application.application.ApplicationId,
                    context: 'submit'
                })
                .then((data) => {
                    if (data) {
                        this.$router.push({
                            name: "genericNotification",
                            query: { msgId: 'submittedApplication' }
                        });
                        // this.$router.push({
                        //     name: "dashboard",
                        //     query: {}
                        // });
                    }
                });
    }

    /** submit back the returned application */
    submitBack(item) {
        this.$router.push({
            name: "dashboard",
            query: {}
        });
    }

    /** get left margin according to the progress */
    get techAppProgressMargin() {
        return this.computedMargin(this.technicalApplicationProgress)
    }

    /** get left margin according to the progress */
    get budgetProgressMargin() {
        return this.computedMargin(this.budgetProgress)
    }

    /** get left margin according to the progress */
    get dueDiligenceProgressMargin() {
        return this.computedMargin(this.dueDiligenceProgress)
    }

    /** get left margin according to the progress */
    get logframeProgressMargin() {
        return this.computedMargin(this.logframeProgress)
    }

    /** get left margin according to the progress */
    get safeguardProgressMargin() {
        return this.computedMargin(this.safeguardProgress)
    }

    get submitProgressMargin() {
        return this.computedMargin(this.submitProgress)
    }

    /** get left margin according to the progress */
    get defaultMargin() {
        return this.computedMargin(0)
    }

    /** get the technical application progress from summary */
    get technicalApplicationProgress() {
        let applSummary: Summary = this.$services.summary.getTechnicalApplicationSummary(this.application.technicalApplication.templates, this.application.data);
        return applSummary.progress();
    }

    /** get the budget progress from summary */
    get budgetProgress() {
        let bgtSummary: Summary = this.$services.summary.getBudgetSummary(this.application.applicationBudget.templates, this.application.data);
        return bgtSummary.progress();
    }

    /** get the budget progress from summary */
    get dueDiligenceProgress() {
        let dueDiligenceSummary: Summary = this.$services.summary.getDueDeligenceSummary(this.application.applicantDueDeligence.templates, this.application.data);
        return dueDiligenceSummary.progress();
    }

    /** get the logframework progress */
    get logframeProgress() {
        let logframeSummary: Summary = this.$services.summary.getLogFrameSummary(this.schema.properties['logFramework'], this.application.data);
        return logframeSummary.progress();        
    }

    /** get safeguard progress */
    get safeguardProgress() {
        if(this.schema && this.schema.properties && this.schema.properties['managementSystem']) {
            let safeguardSummary: Summary = this.$services.summary.getSafeguardSummary(this.schema.properties['managementSystem'], this.application.data);
            return safeguardSummary.progress();
        } else {
            return 0;
        }        
    }

    /** get safeguard progress */
    get submitProgress() {
        if(this.schema && this.schema.properties && this.schema.properties['submit']) {
            let checklistSummary: Summary = this.$services.summary.getSubmitSummary(this.appSubmit.checklist || this.schema.properties['submit'].properties.checklist.properties, this.application.data);
            return checklistSummary.progress();
        } else {
            return 0;
        }        
    }

    get workFlowItems() {
        return this.application.application.WorkflowInfo || {}
    }

    // validate the application form
    validateForm() {
        this.$services.summary.validateForm(
            this.application.application.ApplicationId, 
            this.$services.application.transformAppData(this.application.data))
        .then((resp) => {
            this.validationMessages = resp;
            this.errDialog = true;
        })
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        if(changedRoute && changedRoute.name === 'applSummary') {
            this.resetActiveTabs();
            this.id = changedRoute.params.applicationId;
            this.getApplicantSummary(this.id);
        }
    }

}
